module.exports = __webpack_public_path__ + "media/bootstrap-icons/list-stars-9c9975d0.svg";